import styled from "styled-components";

export const AnnounceSection = styled("div")`
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100px;
    top: -70px;
    left: 0;
    background-size: cover;
    background-repeat: no-repeat;
    z-index: -1;
  }
  &::after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100px;
    bottom: -50px;
    left: 0;
    transform: rotate(180deg);
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 1;
  }
`;